export const MONTHS: { [key: number]: string } = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };
  
  export const keys = [
    {
      index: 0,
      key: "time_slot",
      label: "Time Slot",
      freq: 96,
    },
    {
      index: 1,
      key: "date",
      label: "Date",
      freq: 30,
    },
    {
      index: 2,
      key: "date__day",
      label: "Day",
      freq: 30,
    },
    {
        index: 3,
        key: "date__week",
        label: "Week",
        freq: 8,
    },
    {
      index: 4,
      key: "date__month",
      label: "Month",
      freq: 12,
    },
    {
      index: 5,
      key: "date__year",
      label: "Calendar Year",
      freq: 365,
    },
  ];
  export const Group_keys = [
    {
      key: "station__name",
      label: "Station Name",
    },
  ];
  
  export const CUMULATION_KEYS = [
    {
      key: "average",
      label: "Average",
    },
    {
      key: "cumulative",
      label: "Cumulative",
    },
  ];
 export const units = ["MW", "MWh"];

  export const SLOT_OPTIONS = [
    { value: "1", label: "1 (00:00-00:15)" },
    { value: "2", label: "2 (00:15-00:30)" },
    { value: "3", label: "3 (00:30-00:45)" },
    { value: "4", label: "4 (00:45-01:00)" },
    { value: "5", label: "5 (01:00-01:15)" },
    { value: "6", label: "6 (01:15-01:30)" },
    { value: "7", label: "7 (01:30-01:45)" },
    { value: "8", label: "8 (01:45-02:00)" },
    { value: "9", label: "9 (02:00-02:15)" },
    { value: "10", label: "10 (02:15-02:30)" },
    { value: "11", label: "11 (02:30-02:45)" },
    { value: "12", label: "12 (02:45-03:00)" },
    { value: "13", label: "13 (03:00-03:15)" },
    { value: "14", label: "14 (03:15-03:30)" },
    { value: "15", label: "15 (03:30-03:45)" },
    { value: "16", label: "16 (03:45-04:00)" },
    { value: "17", label: "17 (04:00-04:15)" },
    { value: "18", label: "18 (04:15-04:30)" },
    { value: "19", label: "19 (04:30-04:45)" },
    { value: "20", label: "20 (04:45-05:00)" },
    { value: "21", label: "21 (05:00-05:15)" },
    { value: "22", label: "22 (05:15-05:30)" },
    { value: "23", label: "23 (05:30-05:45)" },
    { value: "24", label: "24 (05:45-06:00)" },
    { value: "25", label: "25 (06:00-06:15)" },
    { value: "26", label: "26 (06:15-06:30)" },
    { value: "27", label: "27 (06:30-06:45)" },
    { value: "28", label: "28 (06:45-07:00)" },
    { value: "29", label: "29 (07:00-07:15)" },
    { value: "30", label: "30 (07:15-07:30)" },
    { value: "31", label: "31 (07:30-07:45)" },
    { value: "32", label: "32 (07:45-08:00)" },
    { value: "33", label: "33 (08:00-08:15)" },
    { value: "34", label: "34 (08:15-08:30)" },
    { value: "35", label: "35 (08:30-08:45)" },
    { value: "36", label: "36 (08:45-09:00)" },
    { value: "37", label: "37 (09:00-09:15)" },
    { value: "38", label: "38 (09:15-09:30)" },
    { value: "39", label: "39 (09:30-09:45)" },
    { value: "40", label: "40 (09:45-10:00)" },
    { value: "41", label: "41 (10:00-10:15)" },
    { value: "42", label: "42 (10:15-10:30)" },
    { value: "43", label: "43 (10:30-10:45)" },
    { value: "44", label: "44 (10:45-11:00)" },
    { value: "45", label: "45 (11:00-11:15)" },
    { value: "46", label: "46 (11:15-11:30)" },
    { value: "47", label: "47 (11:30-11:45)" },
    { value: "48", label: "48 (11:45-12:00)" },
    { value: "49", label: "49 (12:00-12:15)" },
    { value: "50", label: "50 (12:15-12:30)" },
    { value: "51", label: "51 (12:30-12:45)" },
    { value: "52", label: "52 (12:45-13:00)" },
    { value: "53", label: "53 (13:00-13:15)" },
    { value: "54", label: "54 (13:15-13:30)" },
    { value: "55", label: "55 (13:30-13:45)" },
    { value: "56", label: "56 (13:45-14:00)" },
    { value: "57", label: "57 (14:00-14:15)" },
    { value: "58", label: "58 (14:15-14:30)" },
    { value: "59", label: "59 (14:30-14:45)" },
    { value: "60", label: "60 (14:45-15:00)" },
    { value: "61", label: "61 (15:00-15:15)" },
    { value: "62", label: "62 (15:15-15:30)" },
    { value: "63", label: "63 (15:30-15:45)" },
    { value: "64", label: "64 (15:45-16:00)" },
    { value: "65", label: "65 (16:00-16:15)" },
    { value: "66", label: "66 (16:15-16:30)" },
    { value: "67", label: "67 (16:30-16:45)" },
    { value: "68", label: "68 (16:45-17:00)" },
    { value: "69", label: "69 (17:00-17:15)" },
    { value: "70", label: "70 (17:15-17:30)" },
    { value: "71", label: "71 (17:30-17:45)" },
    { value: "72", label: "72 (17:45-18:00)" },
    { value: "73", label: "73 (18:00-18:15)" },
    { value: "74", label: "74 (18:15-18:30)" },
    { value: "75", label: "75 (18:30-18:45)" },
    { value: "76", label: "76 (18:45-19:00)" },
    { value: "77", label: "77 (19:00-19:15)" },
    { value: "78", label: "78 (19:15-19:30)" },
    { value: "79", label: "79 (19:30-19:45)" },
    { value: "80", label: "80 (19:45-20:00)" },
    { value: "81", label: "81 (20:00-20:15)" },
    { value: "82", label: "82 (20:15-20:30)" },
    { value: "83", label: "83 (20:30-20:45)" },
    { value: "84", label: "84 (20:45-21:00)" },
    { value: "85", label: "85 (21:00-21:15)" },
    { value: "86", label: "86 (21:15-21:30)" },
    { value: "87", label: "87 (21:30-21:45)" },
    { value: "88", label: "88 (21:45-22:00)" },
    { value: "89", label: "89 (22:00-22:15)" },
    { value: "90", label: "90 (22:15-22:30)" },
    { value: "91", label: "91 (22:30-22:45)" },
    { value: "92", label: "92 (22:45-23:00)" },
    { value: "93", label: "93 (23:00-23:15)" },
    { value: "94", label: "94 (23:15-23:30)" },
    { value: "95", label: "95 (23:30-23:45)" },
    { value: "96", label: "96 (23:45-00:00)" }
  ];
  